// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__GVlpm","footer":"ModalCreateQualiphyProcedure_footer__150c2","additionData":"ModalCreateQualiphyProcedure_additionData__8Yx1e"};